import { call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import { activateMeter, assignContractor, managementDecision, assignInspector, qualityControl, failedExecution, assignTechnician, assignInspectorCompany } from '../utils/requests';
import { meterActivationSuccess, meterActivationFailed, assignContractorSuccess,  assignContractorFailed, managementDecisionFailed, managementDecisionSuccess,
  awaitingInspectorSuccess, awaitingInspectorFailed,  qualityControlSuccess, qualityControlFailed, failedExecutionSuccess, failedExecutionFailed, assignTechnicianSuccess, assignTechnicianFailed, assignInspectorCompanySuccess, assignInspectorCompanyFailed}  from '../actions/myWorkspace';
import { fetchMyWorkspaceRequest, fetchJobCardsRequest} from '../actions/jobCard'

export function* meterActivationWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.METER_ACTIVATION_REQUEST, meterActivationRequestWatcher);
}



function* meterActivationRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(activateMeter, payload);

      yield put(meterActivationSuccess(response.data));
      yield put(fetchMyWorkspaceRequest());
      yield put(fetchJobCardsRequest());

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(meterActivationFailed(errorPayload));
    }
}

// assign contractor company
export function* assignContractorWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.ASSIGN_CONTRACTOR_REQUEST, assignContractorRequestWatcher);
}
function* assignContractorRequestWatcher(action) {
  try {
      const { payload } = action;
      const response = yield call(assignContractor, payload);

      yield put(assignContractorSuccess(response));
      yield put(fetchMyWorkspaceRequest());
      yield put(fetchJobCardsRequest());
      


    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(assignContractorFailed(errorPayload));
    }
}

// assign inspector company
export function* assignInspectorCompanyWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.ASSIGN_INSPECTOR_COMPANY_REQUEST, assignInspectorCompanyRequestWatcher);
}
function* assignInspectorCompanyRequestWatcher(action) {
  try {
      const { payload } = action;
      const response = yield call(assignInspectorCompany, payload);

      yield put(assignInspectorCompanySuccess(response));
      yield put(fetchMyWorkspaceRequest());
      yield put(fetchJobCardsRequest());
      


    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(assignInspectorCompanyFailed(errorPayload));
    }
}


// assign technician
export function* assignTechnicianWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.ASSIGN_TECHNICIAN_REQUEST, assignTechnicianRequestWatcher);
}
function* assignTechnicianRequestWatcher(action) {
  console.log("technician saga payload: ", action);
  
  try {
      const { payload } = action;
      const response = yield call(assignTechnician, payload);

      yield put(assignTechnicianSuccess(response));
      yield put(fetchMyWorkspaceRequest());
      yield put(fetchJobCardsRequest());

      


    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(assignTechnicianFailed(errorPayload));
    }
}

//  management-decision
export function* managementDecisionWatcherSaga() {
  
  yield takeLatest(ACTIONS_TYPES.MANAGEMENT_DECISION_REQUEST, managementDecisionRequestWatcher);
}
function* managementDecisionRequestWatcher(action) {
  try {
      const { payload } = action;
      const response = yield call(managementDecision, payload);

      yield put(managementDecisionSuccess(response.data));
      yield put(fetchMyWorkspaceRequest());
      yield put(fetchJobCardsRequest());

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(managementDecisionFailed(errorPayload));
    }
}


//  awaitingInspector
export function* awaitingInspectorWatcherSaga() {
  
  yield takeLatest(ACTIONS_TYPES.AWAITING_INSPECTOR_REQUEST, awaitingInspectorRequestWatcher);
}
function* awaitingInspectorRequestWatcher(action) {

  try {
      const { payload } = action;
      const response = yield call(assignInspector, payload);

      yield put(awaitingInspectorSuccess(response.data));
      yield put(fetchMyWorkspaceRequest());
      yield put(fetchJobCardsRequest());

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(awaitingInspectorFailed(errorPayload));
    }
}

//  QUALITY CONTROL
export function* qualityControlWatcherSaga() {
  
  yield takeLatest(ACTIONS_TYPES.QUALITY_CONTROL_REQUEST, qualityControlRequestWatcher);
}
function* qualityControlRequestWatcher(action) {

  try {
      const { payload } = action;
      const response = yield call(qualityControl, payload);

      yield put(qualityControlSuccess(response.data));
      yield put(fetchMyWorkspaceRequest());
      yield put(fetchJobCardsRequest());

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(qualityControlFailed(errorPayload));
    }
}

//  failedExecution
export function* failedExecutionWatcherSaga() {
  
  yield takeLatest(ACTIONS_TYPES.FAILED_EXECUTION_REQUEST, failedExecutionRequestWatcher);
}
function* failedExecutionRequestWatcher(action) {

  try {
      const { payload } = action;
      const response = yield call(failedExecution, payload);

      yield put(failedExecutionSuccess(response.data));
      yield put(fetchMyWorkspaceRequest());
      yield put(fetchJobCardsRequest());

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(failedExecutionFailed(errorPayload));
    }
}

